import camelize from "global/utils/camelize";
import { funAcortarText } from "global/utils/text";
import {
  BodyCardAusente,
  ContainerCardAusente,
  ContainerTopCardAusente,
} from "./localStyle";

const CardAusente = ({
  title,
  horario,
  medico,
  sede,
  setTurnos,
  turnos,
  id,
  actived,
  flgSoloConsulta,
}) => {
  // Te dice si es AM O PM
  const funAMOrPM = (hora) => {
    hora = hora.slice(0, 2);
    hora = Number(hora);
    if (hora > 12) return "PM";
    else return "AM";
  };

  return (
    <ContainerCardAusente>
      <ContainerTopCardAusente>
        {/* <div className="circle-orange">
          <TildeOk color={"var(--color-white)"} />
        </div> */}
        <h1>{funAcortarText(25, title)}</h1>
      </ContainerTopCardAusente>
      <BodyCardAusente>
        <p className="rb18b">
          Horario:{" "}
          <span className="rb18l">{`${horario} ${funAMOrPM(horario)}`}</span>
        </p>
        <p className="rb18b">
          Sede: <span className="rb18l">{funAcortarText(25, sede)}</span>
        </p>
        {/* {flgSoloConsulta ? (
          <p className="rb18b">
            Especialista:{" "}
            <span className="rb18l">
              {funAcortarText(25, camelize(medico))}
            </span>
          </p>
        ) : (
          ""
        )} */}
        <span className="ausente">ausente</span>
        
      </BodyCardAusente>
    </ContainerCardAusente>
  );
};

export default CardAusente;
